export const genArrayOfLength = length => Array.from({ length }, (v, k) => k + 1);
export const getUniqStates = (stateList, prop) =>
  stateList.filter((obj, pos, arr) => arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos);

